// @flow
import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

import { cyan50, cyan300, cyan800 } from 'material-ui/styles/colors';

import { GEOMETRY_FORMATS } from 'utils/geometryFormats';

const styles = {
  container: {
    background: cyan50,
    margin: '0 -24px 12px',
    padding: '0 24px',
  },

  floatingLabel: {
    color: cyan300,
  },

  icon: {
    fill: cyan800,
  },

  label: {
    color: cyan800,
  },

  selectedItem: {
    color: cyan800,
  },
};

export default ({
  geometryFormat,
  setGeometryFormat,
  allowAutodetect = true,
}) => (
  <div style={styles.container}>
    <SelectField
      floatingLabelText="Koordináták formátuma"
      fullWidth
      underlineShow={false}
      value={geometryFormat}
      onChange={(_, __, value) => setGeometryFormat(value)}
      dropDownMenuProps={{ iconStyle: styles.icon }}
      labelStyle={styles.label}
      floatingLabelStyle={styles.floatingLabel}
      selectedMenuItemStyle={styles.selectedItem}
    >
      {allowAutodetect && (
        <MenuItem
          value="autodetect"
          primaryText="Automatikus felismerés"
          secondaryText="A formátum automatikus felismerése"
        />
      )}

      {allowAutodetect && <Divider />}

      {Object.keys(GEOMETRY_FORMATS).map(k => (
        <MenuItem
          key={`geometry-format-${k}`}
          value={k}
          primaryText={GEOMETRY_FORMATS[k].name}
          secondaryText={GEOMETRY_FORMATS[k].sample}
        />
      ))}
    </SelectField>
  </div>
);



// WEBPACK FOOTER //
// ./components/GeometryFormatSelectField/index.js